import { createAction } from "redux-actions";

export const EMAIL_TEMPLATE_LIST = "EMAIL_TEMPLATE_LIST";
export const emailTemplateList = createAction(EMAIL_TEMPLATE_LIST);

export const EMAIL_TEMPLATE_CREATE = "EMAIL_TEMPLATE_CREATE";
export const emailTemplateCreate = createAction(EMAIL_TEMPLATE_CREATE);

export const EMAIL_TEMPLATE_UPDATE = "EMAIL_TEMPLATE_UPDATE";
export const emailTemplateUpdate = createAction(EMAIL_TEMPLATE_UPDATE);

export const EMAIL_TEMPLATE_DELETE = "EMAIL_TEMPLATE_DELETE";
export const emailTemplateDelete = createAction(EMAIL_TEMPLATE_DELETE);

export const EMAIL_TEMPLATE_DETAILE = "EMAIL_TEMPLATE_DETAILE";
export const emailTemplateDetails = createAction(EMAIL_TEMPLATE_DETAILE);
